module.exports = __webpack_public_path__ + "static/media/15_tung_a.217e94ea.ogg";